module.exports = __webpack_public_path__ + "img/64.44562f24.png";